import { render, staticRenderFns } from "./StandardCode.vue?vue&type=template&id=70f26cc5&"
import script from "./StandardCode.vue?vue&type=script&lang=js&"
export * from "./StandardCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports